import { render, staticRenderFns } from "./NewConferenceProduct.vue?vue&type=template&id=6e7b6f38&scoped=true&"
import script from "./NewConferenceProduct.vue?vue&type=script&lang=js&"
export * from "./NewConferenceProduct.vue?vue&type=script&lang=js&"
import style0 from "./NewConferenceProduct.vue?vue&type=style&index=0&id=6e7b6f38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7b6f38",
  null
  
)

export default component.exports